(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.bar = document.querySelector('.announcement-bar-section');
      this.barIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.barBounds = {};

      this.setbarHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setbarHeight.bind(this));

      if (this.barIsAlwaysSticky) {
        this.bar.classList.add('shopify-utility-bar-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hidebarOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setbarHeight() {
      document.documentElement.style.setProperty('--bar-height', `${this.bar.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.barBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.bar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;


      if (scrollTop > this.currentScrollTop && scrollTop > this.barBounds.bottom) {
        this.bar.classList.add('scrolled-past-bar');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.barBounds.bottom) {
        this.bar.classList.add('scrolled-past-bar');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.barBounds.top) {
        this.bar.classList.remove('scrolled-past-bar');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.barIsAlwaysSticky) return;
      this.bar.classList.add('shopify-utility-bar-hidden', 'shopify-utility-bar-sticky');
    }

    reveal() {
      if (this.barIsAlwaysSticky) return;
      this.bar.classList.add('shopify-utility-bar-sticky', 'animate');
      this.bar.classList.remove('shopify-utility-bar-hidden');
    }

    reset() {
      if (this.barIsAlwaysSticky) return;
      this.bar.classList.remove('shopify-utility-bar-hidden', 'shopify-utility-bar-sticky', 'animate');
    }
  }

  customElements.define('sticky-bar', StickyBar);

  } catch(e) { console.error(e); }
})();
})();
